// ponytail: notistack v3 removed withSnackbar HOC.
// Shim wraps useSnackbar for class components mid-migration.
// Deprecate as classes migrate to hooks.
import React from "react";
import { useSnackbar } from "notistack";

export function withSnackbar(Component) {
  return function WithSnackbar(props) {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    return (
      <Component
        {...props}
        enqueueSnackbar={enqueueSnackbar}
        closeSnackbar={closeSnackbar}
      />
    );
  };
}

export default withSnackbar;
